export default __webpack_public_path__ + "static/media/darktemplar_icon.176790ed.png";